export enum Methods {
  EMAIL = "email",
  SMS = "sms",
}
